/**
 * RDLabLocation
 *
 * Location wrapper for the Research view.
 * Maps to the "Research" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { ResearchViewStatic } from '../tycoon/ResearchViewStatic';

// ResearchViewStatic doesn't take props
export const RDLabLocation: React.FC = () => {
  return (
    <LocationWrapper
      location={CampusLocation.RD_LAB}
      title="R&D Laboratory"
    >
      <ResearchViewStatic />
    </LocationWrapper>
  );
};

export default RDLabLocation;
